import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-documents-add',
    templateUrl: './documents-add.component.html',
    styleUrls: ['./documents-add.component.scss'],
})
export class DocumentsAddComponent implements OnInit {
    selectedTab: string = '';
    selectedTabIndex: number = 0;

    constructor(
        private route: ActivatedRoute,
        private location: Location
    ) {}

    ngOnInit(): void {
        this.initTab();
    }

    initTab() {
        this.selectedTab = this.route.snapshot.paramMap.get('panel2');
        if (this.selectedTab == null || this.selectedTab == 'stakt-skjal') {
            this.selectedTab = 'stakt-skjal';
            this.selectedTabIndex = 0;
        } else if (this.selectedTab == 'bunkaskraning') {
            this.selectedTabIndex = 1;
        }
        this.location.go('/skjalasafn/skra-skjal/' + this.selectedTab);
    }

    tabChanged(event: MatTabChangeEvent) {
        if (event.index == 0) {
            this.location.go('/skjalasafn/skra-skjal/stakt-skjal');
        } else if (event.index == 1) {
            this.location.go('/skjalasafn/skra-skjal/bunkaskraning');
        }
    }
}
